import { usePathname } from 'next/navigation';

const useParams = () => {
  const pathname = usePathname();

  const params = pathname?.split('/').filter((a) => a !== '') || [];

  return { params: params };
};

export default useParams;
